import { createContext, useContext, useState, useEffect } from 'react';
import { propertiesAPI } from '../lib/api';

const PropertyContext = createContext(null);

export function PropertyProvider({ children }) {
  const [properties, setProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProps = async () => {
      try {
        const res = await propertiesAPI.list();
        const props = res.data || [];
        setProperties(props);
        const stored = localStorage.getItem('selectedProperty');
        if (stored && props.find((p) => p.id === stored)) {
          setSelectedProperty(stored);
        }
      } catch {
        // silently fail
      } finally {
        setLoading(false);
      }
    };
    fetchProps();
  }, []);

  const selectProperty = (id) => {
    setSelectedProperty(id);
    if (id) {
      localStorage.setItem('selectedProperty', id);
    } else {
      localStorage.removeItem('selectedProperty');
    }
  };

  const selectedPropName = selectedProperty
    ? properties.find((p) => p.id === selectedProperty)?.name || 'All'
    : 'All Properties';

  return (
    <PropertyContext.Provider value={{ properties, selectedProperty, selectProperty, selectedPropName, loading }}>
      {children}
    </PropertyContext.Provider>
  );
}

export const useProperty = () => {
  const ctx = useContext(PropertyContext);
  if (!ctx) throw new Error('useProperty must be used within PropertyProvider');
  return ctx;
};
